export default "__VITE_ASSET__GY61d7Ky__"